/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sl_Plh_IntroInputs */

const vi_sl_plh_intro = /** @type {(inputs: Sl_Plh_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ghi lại các lô đã khiêng ra khỏi kho phân loại để đưa vào lấy hương. Phiếu không trừ tồn kho.`)
};

/**

* @param {Sl_Plh_IntroInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sl_plh_intro = /** @type {((inputs?: Sl_Plh_IntroInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sl_Plh_IntroInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sl_plh_intro(inputs)
});